/**
 * All Models in the application
 */

import Collection from './collections';

import CollectionDetail from './collection-details';

import Appointment from './appointments';

import Doctor from './doctor';

import RegistrationModel from './registrations';

import Bill from './bill';

import DataLog from './data-log';

import BillDetail from './bill-details';

import Sample from './samples';

import Report from './reports';

import EventMasModal from './event-mas';

import ResultEntryModel from './result-entry';

import SCRFilesLinks from './scrfileslinks'

import ModalityGroup from './modality-group';

import MedicalReport from './medical-reports';

import ServiceResultMasterModel from './service-result-master';

import OutBox from './outbox';

import Clinical from './clinical';

import Item from './items';

import Referrer from './referrers';

import Category from './categories';

import Customer from './customers';

import PreregModel from './prereg';

import OpregModel from './opreg';

import EventTransaction from './event-transactions';

import Discount from './discount';

import GeneralList from './general-list';

import Coupon from './coupons';

import RewardTransaction from './reward-transactions';

import TemplateMaster from './template-masters';

import RewardMaster from './reward-masters';

import Opvisit from './opvisit';

import SettingsList from './settings-list';

import ItemRateType from './item-ratetype';

import Department from './department';
import DocFileType from './doc-file-type';

import DocDetail from './doc-details';

import MessageTemplate from './message-template';

import Branches from './branches';


import LabGenSettList from './labgen-settlist';
// import Doctor from './doctor';

import Communication from './communication';

import Preference from './preferences';

import ListProfession from './list-profession';

import ListCountry from './list-country';

import Payment from './payment';
import CoreScript from './core-scripts';

import Nature from './nature';
import ReferenceType from './reference-type';
import CollHead from './coll-head';

import ListMaritalstatus from './listmaritalstatus';


import scrreporttran from './scr-report-tran';

const scrreporttrans= new scrreporttran();

const Collections = new Collection();

const CollectionDetails = new CollectionDetail();

const Appointments = new Appointment();

const Doctors = new Doctor();

const Registrations = new RegistrationModel();

const Samples = new Sample();

const EventMas = new EventMasModal()

const Reports = new Report();

const GeneralLists = new GeneralList();

const Coupons = new Coupon();

const Discounts = new Discount();

const ResultEntry = new ResultEntryModel();

const Bills = new Bill();

const DataLogs = new DataLog();

const BillDetails = new BillDetail();

const SCRFilesLink = new SCRFilesLinks();

const ModalityGroups = new ModalityGroup();

const MedicalReports = new MedicalReport();

const ServiceResultMaster = new ServiceResultMasterModel();

const OutBoxs = new OutBox();

const Payments=new Payment();

const Clinicals = new Clinical();

const MessageTemplates = new MessageTemplate();

const Items = new Item();

const Referrers = new Referrer();

const ReferenceTypes = new ReferenceType();

const ItemRateTypes = new ItemRateType();

const Categories = new Category();

const Customers = new Customer();

const Prereg = new PreregModel();

const Opreg = new OpregModel();

const EventTransactions = new EventTransaction();

const RewardTransactions = new RewardTransaction();

const RewardMasters = new RewardMaster();

const TemplateMasters = new TemplateMaster();
const CoreScripts =new CoreScript();

const Opvisits = new Opvisit();

const Settings = new SettingsList();

const Departments = new Department();

const ListCountries = new ListCountry();

const CollHeads = new CollHead();

const Maritalstatus = new ListMaritalstatus();

// Communcation Model

const Communications = new Communication();
const DocFileTypes = new DocFileType();

const DocDetails = new DocDetail();

const LabGenSettLists = new LabGenSettList();

const Preferences = new Preference();
const Branch = new Branches();

const ListProfessions = new ListProfession();
const NatureList = new Nature()

export {
    Opvisits,
    Collections,
    CollectionDetails,
    scrreporttrans,
    Appointments,
    Doctors,
    Registrations,
    Samples,
    ResultEntry,
    Bills,
    DataLogs,
    BillDetails,
    MessageTemplates,
    Reports,
    SCRFilesLink,
    ModalityGroups,
    MedicalReports,
    ServiceResultMaster,
    OutBoxs,
    Clinicals,
    Items,
    Referrers,
    ReferenceTypes,
    Categories,
    GeneralLists,
    Coupons,
    Discounts,
    Customers,
    Prereg,
    Opreg,
    EventTransactions,
    RewardTransactions,
    RewardMasters,
    TemplateMasters,
    Settings,
    ItemRateTypes,
    Departments,
    CollHeads,
    

    Communications,
    Preferences,
    DocFileTypes,
    DocDetails,
    Branch,
    Maritalstatus,
    LabGenSettLists,
    ListProfessions,
    ListCountries,
    Payments,
    CoreScripts,   
    EventMas,
    NatureList
};
